import {
  MessagesLandingApplicationCard,
  MessagesLandingApplicationMarketingCard,
  MessagesLandingApplicationProjectCard,
  MessagesLandingPlatformMarketingCard,
  MessagesLandingProjectCard,
  MessagesWorkspacesWorkspaceCard,
} from '@/dotnet-client'
import { TabMenuItem } from '@/ux/TabMenu/TabMenu'

export const sortMethod = (
  itemA: MessagesLandingApplicationMarketingCard | MessagesLandingPlatformMarketingCard,
  itemB: MessagesLandingApplicationMarketingCard | MessagesLandingPlatformMarketingCard
) => {
  if (itemA.card.groupings[0].sort_order && itemB.card.groupings[0].sort_order) {
    return itemA.card.groupings[0]?.sort_order - itemB.card.groupings[0]?.sort_order
  } else {
    return 0
  }
}

export const searchFilterGenerator = (searchString: string) => {
  const lowerCaseSearchString = searchString.toLowerCase()

  return (
    item:
      | MessagesWorkspacesWorkspaceCard
      | MessagesLandingApplicationMarketingCard
      | MessagesLandingPlatformMarketingCard
      | MessagesLandingApplicationProjectCard
      | MessagesLandingApplicationCard
      | MessagesLandingProjectCard
  ) => {
    // Return all items if the search string is empty
    if (!searchString || searchString === '') {
      return true
    }

    // Check for fields specific to workspace cards
    if ('application' in item && 'organisation' in item && 'project' in item) {
      return (
        item.application.toLowerCase().includes(lowerCaseSearchString) ||
        item.organisation.toLowerCase().includes(lowerCaseSearchString) ||
        item.project.toLowerCase().includes(lowerCaseSearchString)
      )
    }

    // Fallback: Perform a generic search in the stringified object
    return JSON.stringify(item).toLowerCase().includes(lowerCaseSearchString)
  }
}
